import { render, staticRenderFns } from "./PayPalButtonPopup.vue?vue&type=template&id=a0e3ed66&scoped=true"
import script from "./PayPalButtonPopup.vue?vue&type=script&lang=js"
export * from "./PayPalButtonPopup.vue?vue&type=script&lang=js"
import style0 from "./PayPalButtonPopup.vue?vue&type=style&index=0&id=a0e3ed66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e3ed66",
  null
  
)

export default component.exports